class CartDrawer extends HTMLElement {
    constructor() {
        super();
        //this.initEventListeners();
    }
    connectedCallback() {
        this.observer = new MutationObserver(() => {
            this.initEventListeners();
        });
        this.observer.observe(this, {
            childList: true,
        });
        this.initEventListeners();
    }

    disconnectedCallback() {
        this.observer.disconnect();
    }

    initEventListeners() {
        this.increaseQuantityButtons = this.querySelectorAll(".qty-plus-btn");
        this.decreaseQuantityButtons = this.querySelectorAll(".q-minus");
        this.quantityInputs = this.querySelectorAll(".cart-drawer-qty");

        this.increaseQuantityButtons.forEach((button) => {
            button.addEventListener("click", this.increaseQuantity.bind(this));
        });

        this.decreaseQuantityButtons.forEach((button) => {
            button.addEventListener("click", this.decreaseQuantity.bind(this));
        });

        this.quantityInputs.forEach((input) => {
            input.addEventListener("change", this.manualUpdate.bind(this));
        });
    }

    manualUpdate(event) {
        let AddClass = event.target.closest(".slide-cart-body");
        AddClass.classList.add("ajax-class");

        const input = event.target
            .closest(".qty-box")
            .querySelector(".cart-drawer-qty");
        input.value = parseInt(input.value, 10);
        this.updateQuantity(input);
    }

    increaseQuantity(event) {
        if (event.target.classList.contains("q-plus")) {
            let AddClass = event.target.closest(".slide-cart-body");
            AddClass.classList.add("ajax-class");

            const input = event.target
                .closest(".qty-box")
                .querySelector(".cart-drawer-qty");
            input.value = parseInt(input.value, 10) + 1;
            this.updateQuantity(input);
        }
    }

    decreaseQuantity(event) {
        if (event.target.classList.contains("q-minus")) {
            let AddClass = event.target.closest(".slide-cart-body");
            AddClass.classList.add("ajax-class");
            const input = event.target
                .closest(".qty-box")
                .querySelector(".cart-drawer-qty");
            input.value = parseInt(input.value, 10) - 1;
            this.updateQuantity(input);
        }
    }
    updateToCart(data) {
        fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            })
            .then(function(response) {               
                if (response.ok) {
                    let cartAjax = new Cart();
                    cartAjax.fetchData();
                } else {
                   let cartAjax = new Cart();
                    cartAjax.fetchData();
                    
                 /* let removeCartClass = document.querySelector(".slide-cart-body");                  
                 removeCartClass.classList.remove("ajax-class"); */
                    
                    //throw new Error("Request was not successful");
                }
            })
            .then(function(item) {})
            .catch(function(error) {});
    }

    updateQuantity(event) {
        const input = event.target;
        const lineItemKey = event.dataset.lineItemKey;
        const VariantId = event.dataset.id;
        const Quantity = event.value;

        const items = {
            id: lineItemKey,
            quantity: Quantity,
        };

        this.updateToCart(items);
    }
}

customElements.define("side-cart", CartDrawer);